
const UserIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z" stroke="#3107AA" stroke-width="1.5" stroke-miterlimit="10" />
            <path d="M3.875 26.9992C5.10367 24.8706 6.87104 23.103 8.99944 21.874C11.1278 20.6451 13.5423 19.998 16 19.998C18.4577 19.998 20.8722 20.6451 23.0006 21.874C25.129 23.103 26.8963 24.8706 28.125 26.9992" stroke="#3107AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default UserIcon